import styled from 'styled-components';

export const NewPocketStyle = styled.div``